// const setAuth = async (store) => {
//   store.$api.auth.setAuthHeader();
//   await store.dispatch("Auth/getMe");
// };

// export default async function auth({to, next, store, nextMiddleware}) {
//   if (store.state.Auth.user === null) {
//     const token = store.$jwt.getToken();
//     if (token) {
//       await setAuth(store);
//     } else {
//       if (to.name !== "RouterLoginPage") next({name: "RouterLoginPage"});
//     }
//     console.log(1);
//     console.log(store.state.Auth.user);
//   }
//   return nextMiddleware();
// }


export default async function auth({to, next, store, nextMiddleware}) {
  if (to.name === "RouterLoginPage") return;
  const token = store.$jwt.getToken();
  if (token) {
    store.$api.auth.setAuthHeader();
  } else {
    next({name: "RouterLoginPage"});
    return
  }

  if (store.state.Auth.user === null) {
    const res = await store.dispatch("Auth/getMe");
    if (!res) {
      next({name: "RouterLoginPage"});
    }
  }



  return nextMiddleware();
}